import { createSlice, createAsyncThunk, createEntityAdapter } from "@reduxjs/toolkit";
import { request } from "@/utils/api";

const pincodeAdapter = createEntityAdapter({
    selectId: (pincode) => pincode._id,
    sortComparer: (a, b) => new Date(b.createdAt) - new Date(a.createdAt),
});

export const savePincodes = createAsyncThunk(
    "pincode/save",
    async ({ file, data }, { rejectWithValue }) => {
        try {
            const formData = new FormData();
            formData.append("pincodes", file);
            formData.append("data", data);

            const response = await request({
                endpoint: "/admin/savePincodes",
                method: "POST",
                body: formData,
                headers: { "Content-Type": "multipart/form-data" },
            });

            if (!response.success) {
                return rejectWithValue(response.error || "Failed to save pincodes");
            }

            return response.data;
        } catch (error) {
            return rejectWithValue(error.message || "Failed to save pincodes");
        }
    }
);

const pincodeSlice = createSlice({
    name: "pincode",
    initialState: pincodeAdapter.getInitialState({
        loading: false,
        error: null,
    }),
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(savePincodes.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(savePincodes.fulfilled, (state, action) => {
                state.loading = false;
                //pincodeAdapter.upsertOne(state, { ...action.payload, id: new Date().toISOString() });
            })
            .addCase(savePincodes.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    },
});

export default pincodeSlice.reducer;
export const {
    selectAll: selectAllPincodes,
    selectById: selectPincodeById,
    selectIds: selectPincodeIds,
} = pincodeAdapter.getSelectors((state) => state.pincode);
